import { __awaiter, __generator } from "tslib";
import { sleep } from '../utils/common';
export var poller = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.attempts, attempts = _c === void 0 ? 10 : _c, _d = _b.delay, delay = _d === void 0 ? 500 : _d, _e = _b.timeout, timeout = _e === void 0 ? 5000 : _e;
    return function (handler) {
        return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var timeIsOver, timeLabel, noNeedRetry, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timeIsOver = false;
                        timeLabel = setTimeout(function () {
                            timeIsOver = true;
                            reject(new Error('TIMEOUT'));
                        }, timeout);
                        _a.label = 1;
                    case 1:
                        if (timeIsOver) {
                            return [2];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, handler()];
                    case 3:
                        noNeedRetry = _a.sent();
                        if (noNeedRetry) {
                            clearTimeout(timeLabel);
                            return [2, resolve('SUCCESS')];
                        }
                        return [3, 5];
                    case 4:
                        err_1 = _a.sent();
                        return [3, 8];
                    case 5:
                        if (attempts < 1) {
                            return [3, 8];
                        }
                        return [4, sleep(delay)];
                    case 6:
                        _a.sent();
                        attempts -= 1;
                        _a.label = 7;
                    case 7:
                        if (attempts > 0) return [3, 1];
                        _a.label = 8;
                    case 8:
                        clearTimeout(timeLabel);
                        reject(new Error('ATTEMPTS_ARE_OVER'));
                        return [2];
                }
            });
        }); });
    };
};
